import data from '../data/data.json';
import metroClusters from '../data/metroClusters.json';

import { getCluster, Q, getClusterBySchool } from './helpers';

const activeSchoolID = Q.school;
const activeClusterID = Q.cluster;
let activeCluster;
let activeSchool;

data.clusters.sort((a, b) => {
  if (a.name > b.name) {
    return 1;
  }
  if (a.name < b.name) {
    return -1;
  }
  return 0;
});

if (activeClusterID) {
  activeCluster = getCluster(activeClusterID, data);
  if (!activeCluster) {
    console.error('No cluster data for cluster code ' + activeClusterID);
  }
} else if (activeSchoolID) {
  activeCluster = getClusterBySchool(activeSchoolID, data);
  if (!activeCluster) {
    console.error('No cluster data for school code ' + activeSchoolID);
  }
}

if (!activeCluster) {
  activeCluster = getCluster(data.clusters[0].uid, data);
}

activeCluster.isActive = true;

activeCluster.schools.sort((a, b) => a.name > b.name);
activeCluster.schools.forEach(obj => {
  if (parseInt(obj.uid, 10) === parseInt(activeSchoolID, 10)) {
    obj.isActive = true;
    activeSchool = obj;
  }
});

export {
  data,
  activeSchoolID,
  activeClusterID,
  activeCluster,
  activeSchool,
  metroClusters,
};



// WEBPACK FOOTER //
// ./src/modules/get-data.js